const messages = {
    buy_btc: 'Buy BTC',
    header: 'LOAD CASH TO BUY BITCOIN',
    sign_in: 'Sign in',
};

export default messages;
